/**
 * Formats a number with a specified precision.
 *
 * @param {number} number - The number to format.
 * @param {string} [placeholder="--"] - The placeholder value to use if the number is not valid.
 * @param {number} [precision=2] - The number of decimal places to round the number to.
 * @returns {string} The formatted number.
 */
const formatNumber = (number, placeholder = "--", precision = 2) =>
  !isNaN(parseFloat(number))
    ? parseFloat(number).toFixed(precision)
    : placeholder;
export default formatNumber;
